import { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  width?: number,
  height?: number,
  color?: StrokeColors
}

const HighBandwidth = ({ color = 'stroke-white'}: Props) => {
  return (
    
      <svg className={color} width="30" height="30" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25 12.7107C25 19.1783 20.8274 18.566 14.2 18.566C7.57258 18.566 1 19.1783 1 12.7107M25 12.7107C25 6.24305 19.6274 1 13 1M25 12.7107H22M1 12.7107C1 6.24305 6.37258 1 13 1M1 12.7107H4M13 1V3.92767M21.4941 4.5132L14.7999 10.9541M21.4941 21L21.2494 20.7612C20.4193 19.9511 20.0042 19.546 19.5198 19.2563C19.0903 18.9995 18.6221 18.8102 18.1323 18.6955C17.5799 18.566 16.9929 18.566 15.8188 18.566L10.1811 18.5661C9.00712 18.5661 8.4201 18.5661 7.86768 18.6955C7.37791 18.8103 6.9097 18.9995 6.48024 19.2564C5.99584 19.546 5.58076 19.9511 4.75059 20.7613L4.50596 21M4.50596 4.5132L6.5897 6.54671M15.4 12.7107C15.4 14.0042 14.3255 15.0528 13 15.0528C11.6745 15.0528 10.6 14.0042 10.6 12.7107C10.6 11.4172 11.6745 10.3685 13 10.3685C14.3255 10.3685 15.4 11.4172 15.4 12.7107Z" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>  )
}

export default HighBandwidth